import { render, staticRenderFns } from "./ConnectionsIsland.vue?vue&type=template&id=459e38f2&"
import script from "./ConnectionsIsland.vue?vue&type=script&lang=js&"
export * from "./ConnectionsIsland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports